<template>
  <div>
    <date-picker v-model="ls.day" valueType="format" :clearable="false"/>
    <br />
    <button @click="prev()">&lt; Prev</button>
    <button @click="next()">Next &gt;</button>
    
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import localstorageMixin from '@/mixins/localstorageMixin.js'

export default {
  name:'ShiftDatePicker',
  mixins: [localstorageMixin],
  data(){
    return {
      ls:{
        day: '2020-08-01',
      }
    }
  },
  mounted(){
    this.shiftStore.day = this.ls.day;
  },
  watch:{
    day: {
      immediate: true,
      handler(newVal, oldVal) {
        this.shiftStore.day = newVal
      },
    },
  },
  components : {DatePicker},
  inject: ['shiftsPage'],
  computed:{
    shiftStore(){
      return this.shiftsPage.$refs.shiftStore;
    },
    day(){
      return this.ls.day
    }
  },
  methods:{
    next(){
      this.ls.day = moment(this.ls.day).add(1, 'day').format('YYYY-MM-DD')
    },
    prev(){
      this.ls.day = moment(this.ls.day).subtract(1, 'day').format('YYYY-MM-DD')
    },
  }
}
</script>